"use client";

import { useState, useEffect } from "react";

export function usePWA() {
	const [isPWA, setIsPWA] = useState(false);

	useEffect(() => {
		const check = () => {
			const standalone =
				window.matchMedia("(display-mode: standalone)").matches ||
				window.navigator.standalone === true ||
				document.referrer.includes("android-app://");

			setIsPWA(standalone);
		};

		check();

		const mq = window.matchMedia("(display-mode: standalone)");
		mq.addEventListener("change", check);
		return () => mq.removeEventListener("change", check);
	}, []);

	return isPWA;
}
